<template>
  <footer class="footer-container">
    <!-- 上红框区域 -->
    <div class="footer-top">
      <div class="footer-top-content">
        <div class="footer-top-left">
          <img
            src="@/assets/head-foot/congzai-logo-bottom-left.svg"
            alt="聪崽AI"
            class="logo-image"
          />
          <span class="slogan">会思考，才更会学习！</span>
        </div>
        <div class="footer-top-right">
          <img
            src="@/assets/head-foot/congzai-logo-bottom-right.svg"
            alt="CONGZAI"
            class="logo-right"
          />
        </div>
      </div>
    </div>

    <!-- 下红框区域 -->
    <div class="footer-bottom">
      <div class="footer-bottom-content">
        <div class="footer-contact-info">
          <div class="contact-item">
            <img
              src="@/assets/head-foot/emial-whtie.svg"
              alt="邮箱"
              class="contact-icon"
            />
            <span class="contact-text">邮箱：xixinliang@congzai.net </span>
          </div>
          <div class="contact-item">
            <img
              src="@/assets/head-foot/address-white.svg"
              alt="地址"
              class="contact-icon"
            />
            <span class="contact-text"
              >地址：海南省海口市秀英区科技大道88号</span
            >
          </div>
          <div class="contact-item">
            <img
              src="@/assets/head-foot/time-white.svg"
              alt="工作时间"
              class="contact-icon"
            />
            <span class="contact-text">工作时间：周一至周日 9:00-22:00</span>
          </div>
        </div>

        <div class="footer-copyright-info">
          <span class="copyright-text"
            >版权所有©智伴涌现人工智能科技（海口）有限责任公司2026｜
            <a
              href="https://beian.miit.gov.cn/#/Integrated/index"
              target="_blank"
              rel="noopener noreferrer"
              class="icp-link"
            >
              琼ICP备2025063080号-1
            </a>
          </span>
          <div class="footer-links">
            <!-- <a href="#" class="footer-link">聪崽隐私政策</a>
            <a href="#" class="footer-link">使用条款信息</a>
            <a href="#" class="footer-link">Cookie政策</a> -->
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script setup></script>

<style scoped>
.footer-container {
  width: 100%;
  background-color: #1a1a2e;
  color: #ffffff;
  margin-top: auto;
}

/* 上红框区域 */
.footer-top {
  background-color: #1a1a2e;
  padding: 20px 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.footer-top-content {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
}

.footer-top-left {
  display: flex;
  align-items: center;
  gap: 12px;
}

.logo-left {
  height: 30px;
  width: auto;
}

.slogan {
  font-size: 14px;
  color: #ffffff;
  font-weight: 500;
}

.logo-right {
  height: 20px;
  width: auto;
}

/* 下红框区域 */
.footer-bottom {
  background-color: #1a1a2e;
  padding: 20px 0;
}

.footer-bottom-content {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  box-sizing: border-box;
}

.footer-contact-info {
  display: flex;
  gap: 30px;
  margin-bottom: 10px;
  flex-wrap: wrap;
}

.contact-item {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  color: #ffffff;
}

.contact-icon {
  height: 14px;
  width: 14px;
}

.contact-text {
  color: #ffffff;
}

.footer-copyright-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 12px;
  color: #ffffff;
  flex-wrap: wrap;
  gap: 10px;
}

.copyright-text {
  color: #ffffff;
}

.footer-links {
  display: flex;
  gap: 16px;
}

.footer-link {
  color: #ffffff;
  text-decoration: none;
  font-size: 12px;
  transition: color 0.3s ease;
}

.footer-link:hover {
  color: #1890ff;
}

.icp-link {
  color: inherit;
  text-decoration: none;
  cursor: pointer;
  transition: color 0.3s ease;
}

.icp-link:hover {
  color: #1890ff;
  text-decoration: underline;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .footer-top-content,
  .footer-bottom-content {
    padding: 0 10px;
  }

  .footer-top-left {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }

  .footer-contact-info {
    flex-direction: column;
    gap: 10px;
    align-items: flex-start;
  }

  .footer-copyright-info {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }

  .footer-links {
    gap: 12px;
    flex-wrap: wrap;
  }
}
</style>
